import { IconButton, InputAdornment, TextFieldProps } from '@material-ui/core';
import { useState } from 'react';
import TextInput from '.';
import { FormikPropType } from '../Formik';

export default function SecureInput({
    label,
    showSecure = true,
    ...rest
}: TextFieldProps & { showSecure?: boolean }) {
    const [showPassword, setPassword] = useState<boolean>(false);
    return (
        <TextInput
            {...rest}
            type={!showPassword ? 'password' : 'text'}
            id="outlined-adornment-password"
            label={label}
            onPaste={(e) => {
                e.preventDefault();
                return false;
            }}
            InputProps={{
                endAdornment: showSecure && (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={() => setPassword(!showPassword)}
                            aria-label="toggle password visibility"
                            edge="end"
                        >
                            {showPassword ? (
                                <img src="/images/eye-open.svg" alt="icon" />
                            ) : (
                                <img src="/images/eye-close.svg" alt="icon" />
                            )}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
}
